<template>
  <tr>
    <td>
      <h3 class="text-sm font-normal text-gray-800">
        {{ offerLine.description }}
      </h3>
    </td>
    <td class="text-right text-sm text-gray-800">
      <span v-if="freeOfCharge" class="uppercase">included</span>
      <span v-else class="tabular-nums">{{ price }} &euro;</span>
    </td>
  </tr>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  props: {
    offerLine: {
      type: Object,
      required: true,
    },
  },
  computed: {
    freeOfCharge() {
      return this.offerLine.pricePerUnit === 0;
    },
    price() {
      return this.offerLine.pricePerUnit * this.offerLine.quantity;
    },
  },
};
</script>
